import { fetchJson } from './client';

export type ConversionStatus = 'queued' | 'running' | 'succeeded' | 'failed' | 'cancelled';

export interface ConversionJob {
  id: string;
  projectId: string;
  kind: string;
  status: ConversionStatus;
  stage: string | null;
  name: string | null;
  rawKey: string;
  outputKey: string;
  inputBytes: string | null;
  outputBytes: string | null;
  pointCount: string | null;
  cpu: number | null;
  memory: number | null;
  taskArn: string | null;
  errorMessage: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
  startedAt: string | null;
  finishedAt: string | null;
}

export const convert = {
  status: () => fetchJson<{ configured: boolean; reason: string | null }>('/convert/status'),
  createJob: (projectId: string, key: string, name?: string) =>
    fetchJson<{ job: ConversionJob }>('/convert/jobs', { method: 'POST', body: JSON.stringify({ projectId, key, name }) }),
  listJobs: (projectId: string) =>
    fetchJson<{ jobs: ConversionJob[]; configured: boolean; reason: string | null }>(`/convert/jobs?projectId=${encodeURIComponent(projectId)}`),
  retry: (id: string) => fetchJson<{ job: ConversionJob }>(`/convert/jobs/${id}/retry`, { method: 'POST' }),
  cancel: (id: string) => fetchJson<{ job: ConversionJob }>(`/convert/jobs/${id}/cancel`, { method: 'POST' }),
};
